import React from 'react'

import ExceptionTailPill from '../ExceptionTailPill'

// No Access: the sub-option (Blocked / Not out / Locked) read from exception.description.
type NoAccessTailProps = {
  value?: string | null
}

const NoAccessTail: React.FC<NoAccessTailProps> = ({ value }) => {
  if (!value) return null
  return <ExceptionTailPill>{value}</ExceptionTailPill>
}

export default NoAccessTail
